import React from 'react';
import Header from '../header/Header';
import './Pages.css';
import Footer from "../footer/Footer";

const Information = () => {
    return (<div className="page-wrapper">
        <Header/>
        <div className="information">
            <h2>ΧΡΗΣΙΜΟΙ ΟΔΗΓΟΙ</h2>
            <ul>
                <li><a href="https://rarediseasesgreece.gr/odigos-dikaiomaton/" target="_blank"
                       rel="noopener noreferrer">Οδηγός Δικαιωμάτων και Κοινωνικών Παροχών Ατόμων που ζουν με Σπάνια
                    Νοσήματα</a></li>
                <li><a href="https://rarediseasesgreece.gr/odigos-prosvasis/" target="_blank"
                       rel="noopener noreferrer">Οδηγός Πρόσβασης σε Θεραπείες και Ορφανά Φάρμακα για Σπάνια
                    Νοσήματα</a></li>
            </ul>

            <h2>ΧΡΗΣΙΜΕΣ ΠΗΓΕΣ</h2>
            <ul>
                <li><a href="https://www.orpha.net/" target="_blank" rel="noopener noreferrer">Orphanet</a></li>
                <li><a href="https://pubmed.ncbi.nlm.nih.gov/" target="_blank" rel="noopener noreferrer">PubMed</a>
                </li>
                <li><a href="http://ClinicalTrials.Gov" target="_blank"
                       rel="noopener noreferrer">ClinicalTrials.Gov</a></li>
                <li><a href="https://www.clinicaltrialsregister.eu/" target="_blank" rel="noopener noreferrer">EU
                    Clinical Trial Registry</a></li>
            </ul>

            <h2>ΧΡΗΣΙΜΕΣ ΔΙΕΥΘΥΝΣΕΙΣ & ΤΗΛΕΦΩΝΑ</h2>
            <p>ΥΠΟΥΡΓΕΙΟ ΥΓΕΙΑΣ</p>
            <p><a href="https://www.moh.gov.gr/" target="_blank"
                  rel="noopener noreferrer">https://www.moh.gov.gr/</a></p>
            <p>Διεύθυνση: Αριστοτέλους 17, Αθήνα 104 33</p>
            <p>Τηλέφωνο: 21 3216 1000</p>

            <p>ΕΘΝΙΚΟΣ ΟΡΓΑΝΙΣΜΟΣ ΦΑΡΜΑΚΩΝ (Ε.Ο.Φ.)</p>
            <p><a href="https://www.eof.gr/" target="_blank" rel="noopener noreferrer">https://www.eof.gr/</a></p>
            <p>Μεσογείων 284,15562 Χολαργός</p>
            <p>Τηλ.κέντρο : 213 2040 000</p>
            <p>Τηλεφωνικός κατάλογος</p>

            <p>Ι.Φ.Ε.Τ. Μ.Α.Ε.</p>
            <p><a href="https://www.ifet.gr/" target="_blank" rel="noopener noreferrer">https://www.ifet.gr/</a></p>
            <p>18 χιλ. Λεωφ. Μαραθώνος | 153 51 | Παλλήνη, Αττική</p>
            <p>Τηλεφωνικό Κέντρο: 213 2002 400</p>

            <p>Ε.Ο.Π.Υ.Υ.</p>
            <p><a href="https://www.eopyy.gov.gr/" target="_blank"
                  rel="noopener noreferrer">https://www.eopyy.gov.gr/</a></p>
            <p>Αποστόλου Παύλου 12, Μαρούσι Αττική</p>
            <p>2108110500</p>
            <p>Χρήσιμα τηλέφωνα</p>

            <p>ΗΔΙΚΑ</p>
            <p><a href="https://www.idika.gr/" target="_blank" rel="noopener noreferrer">https://www.idika.gr/</a>
            </p>
            <p>Ηλεκτρονική Διακυβέρνηση Κοινωνικής Ασφάλισης Α.Ε. - Η.ΔΙ.Κ.Α. Α.Ε.</p>
            <p>Έδρα: Λυκούργου 10, 10551, Αθήνα</p>
            <p>Υποκατάστημα: Λεωφ. Συγγρού 101, 11745, Αθήνα</p>
            <p>Τηλ. Κέντρο: 11131</p>

            <h2>ΧΡΗΣΙΜΕΣ ΥΠΗΡΕΣΙΕΣ – ΟΡΓΑΝΙΣΜΟΙ</h2>
            <ul>
                <li><a href="https://rarediseasesgreece.gr/" target="_blank" rel="noopener noreferrer">Ένωση
                    Σπανίων Ασθενών Ελλάδος</a></li>
                <li><a href="https://greekpatient.gr/" target="_blank" rel="noopener noreferrer">Ένωση Ασθενών
                    Ελλάδος</a></li>
                <li><a href="https://www.synigoros.gr/el" target="_blank" rel="noopener noreferrer">Συνήγορος του
                    πολίτη</a></li>
                <li><a
                    href="https://www.moh.gov.gr/articles/citizen/dikaiwmata-lhptwn-yphresiwn-ygeias/foreis-kai-armodia-organa-prostasias-dikaiwmatwn/5263-grafeia-prostasias-dikaiwmatwn-lhptwn-riwn-yphresiwn-ygeias-twn-nosokomeiwn"
                    target="_blank" rel="noopener noreferrer">Γραφεία προστασίας δικαιωμάτων ληπτών/-ριών
                    υπηρεσιών υγείας των Νοσοκομείων</a></li>
                <li><a href="https://tomy.moh.gov.gr/help.aspx" target="_blank" rel="noopener noreferrer">Τ.ΟΜ.Υ. -
                    Ομάδες Παροχής Υπηρεσιών Πρωτοβάθμιας Φροντίδας Υγείας (Π.Φ.Υ.)</a></li>
                <li><a href="https://www.pasteur.gr/el" target="_blank" rel="noopener noreferrer">Ελληνικό
                    Ινστιτούτο Παστέρ</a></li>
                <li><a href="https://ich.gr/" target="_blank" rel="noopener noreferrer">Ινστιτούτο Υγείας του
                    Παιδιού</a></li>
                <li><a href="https://eody.gov.gr/eody/" target="_blank" rel="noopener noreferrer">Εθνικός
                    Οργανισμός Δημόσιας Υγείας</a></li>
                <li><a href="https://www.uniwa.gr/spoydes/scholes-kai-tmimata/sph/" target="_blank"
                       rel="noopener noreferrer">Σχολή Δημόσιας Υγείας</a></li>
                <li><a href="https://opeka.gr/kentra-koinotitas/" target="_blank" rel="noopener noreferrer">Λίστα
                    Κέντρων Κοινότητας Ο.Π.Ε.Κ.Α.</a></li>
                <li><a href="https://socialobservatory.crete.gov.gr/index.php?com=booklet" target="_blank"
                       rel="noopener noreferrer">Λίστα Κοινωνικών Υπηρεσιών Περιφέρειας Κρήτης</a></li>
                <li><a
                    href="https://docs.google.com/spreadsheets/d/1dsRSlNa0YnfSi2so9I-mHNH2gBO7TLXf/edit?gid=39563850#gid=39563850"
                    target="_blank" rel="noopener noreferrer">Λίστα ΚΕ.Δ.Α.Σ.Υ.</a></li>
                <li><a href="http://argo.org.gr/index.php/foreis" target="_blank" rel="noopener noreferrer">Φορείς
                    Ψυχικής Υγείας</a></li>
                <li>Κοινωνικές Υπηρεσίες των Δήμων / Γραφεία ΑμεΑ των Δήμων</li>
                <li>Πρόγραμμα «Βοήθεια στο Σπίτι» που παρέχεται από τους Δήμους</li>
                <li>Κοινωνικές Υπηρεσίες Νοσοκομείων</li>
            </ul>

            <h2>Λοιπά Χρήσιμα Τηλέφωνα</h2>
            <ul>
                <li>1555 Εξυπηρέτηση Πολιτών για ασφαλιστικά, εργασιακά και κοινωνικά θέματα</li>
                <li>1535 / 14500 Ραντεβού σε δημόσια νοσοκομεία</li>
                <li>1889 Yπηρεσία του Υπουργείου Μεταφορών για ΑμεΑ</li>
                <li>10306 Γραμμή Ψυχοκοινωνικής Υποστήριξης</li>
                <li>1056 Εθνική Γραμμή SOS για Παιδιά</li>
            </ul>
        </div>
        <Footer/>
    </div>);
};

export default Information;